// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"2793c4b9","739":"33b6d082","981":"395825ff"}[chunkId] + ".chunk.css";
};